export default {
    lang: 'de',
    fallbackLang: 'en',
    resolve: async (lang) => {
        const langs = import.meta.glob('../../../lang/*.json');
        return await langs[`../../../lang/${lang}.json`]();
    },
};
